import type { ReactNode } from 'react'
import Footer from './Footer'
import ProgressTracker, { type ProgressStep } from './ProgressTracker'
import TopBar from './TopBar'

interface OnboardingLayoutProps {
  steps?: ProgressStep[]
  activeKey?: string
  children: ReactNode
  contentClassName?: string
}

// Shared onboarding chrome: 56px TopBar, optional ProgressTracker, content,
// in-flow Footer. One surface (#fbf9fa), responsive padding 16/64px. All spacing
// is direction-agnostic so the layout adapts if RTL is added later.
export default function OnboardingLayout({
  steps,
  activeKey,
  children,
  contentClassName = '',
}: OnboardingLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-ob-surface text-ob-on-surface">
      <TopBar />
      {steps && activeKey && (
        <div className="shrink-0 border-b border-ob-secondary/20 bg-ob-surface px-4 py-3 md:px-16">
          <ProgressTracker steps={steps} activeKey={activeKey} />
        </div>
      )}
      <main className={`w-full flex-1 px-4 py-10 md:px-16 md:py-16 ${contentClassName}`}>
        {children}
      </main>
      <Footer />
    </div>
  )
}
